import { FiltersFormTableElectoralCard } from 'front-office/view-models/electoral-card';
import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValues: FiltersFormTableElectoralCard = {
  order: {},
  page: 0,
  rowsPerPage: 10,
};

const ElectoralCardInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValues}>
      <Outlet />
    </FilterTableProvider>
  );
};

ElectoralCardInitializer.displayName = 'Electoral Card Initializer component';

export default ElectoralCardInitializer;
